import { createContext } from "react";
import type { Session, User } from "@supabase/supabase-js";

import type { AppRole } from "@/config/constants";
import type { Membership, PlatformAdmin, UserProfile } from "@/types";

export interface AuthState {
  user: User | null;
  session: Session | null;
  profile: UserProfile | null;
  platformAdmin: PlatformAdmin | null;
  isPlatformAdmin: boolean;
  authLoadError: string | null;
  memberships: Membership[];
  activeTenantId: string | null;
  activeOrganizationId: string | null;
  activeRole: AppRole | null;
  hasClientAccess: boolean;
  isLoading: boolean;
  isAuthenticated: boolean;
}

export interface AuthContextType extends AuthState {
  signIn: (email: string, password: string) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
  resetPassword: (email: string) => Promise<{ error: Error | null }>;
  updatePassword: (password: string) => Promise<{ error: Error | null }>;
  setActiveTenant: (tenantId: string) => void;
  refreshProfile: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
